import { Action, State, StateContext } from '@ngxs/store';
import _ from 'lodash';
import { Injectable } from '@angular/core';
import { CloseChatListAction, OpenChatListAction, ToggleChatListAction } from './chat-list.actions';

export interface ChatListStateModel {
   isOpen: boolean;
}

@State<ChatListStateModel>({
   name: 'chatList',
   defaults: {
      isOpen: false,
   },
})
@Injectable()
export class ChatListState {
   @Action(OpenChatListAction)
   public openChatList(ctx: StateContext<ChatListStateModel>, action: OpenChatListAction) {
      ctx.patchState({
         isOpen: true,
      });
   }

   @Action(CloseChatListAction)
   public closeChatList(ctx: StateContext<ChatListStateModel>, action: CloseChatListAction) {
      ctx.patchState({
         isOpen: false,
      });
   }

   @Action(ToggleChatListAction)
   public toggleChatList(ctx: StateContext<ChatListStateModel>, action: ToggleChatListAction) {
      ctx.patchState({
         isOpen: !ctx.getState().isOpen,
      });
   }
}
